import { render, staticRenderFns } from "./GeneralSearchComponent.vue?vue&type=template&id=6a58425f&scoped=true&"
import script from "./GeneralSearchComponent.vue?vue&type=script&lang=js&"
export * from "./GeneralSearchComponent.vue?vue&type=script&lang=js&"
import style0 from "./GeneralSearchComponent.vue?vue&type=style&index=0&id=6a58425f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a58425f",
  null
  
)

export default component.exports